import { Component, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { DiscoveryService } from "../../../domain/services/discovery/discovery.service";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatCardModule } from "@angular/material/card";
import { MatDividerModule } from "@angular/material/divider";
import { TaskService } from "../../../domain/services/task/task.service";
import { TaskModel } from "../../../domain/models/task.model";
import { TaskStatusEnum } from "../../../domain/enums/task-status.enum";
import { TaskDetailHeaderComponent } from "./components/task-detail-header/task-detail-header.component";
import {
  DefaultEnrollmentComponent
} from "../../../common/enrollment-request/default-enrollment/default-enrollment.component";
import {
  IndividualBedEnrollmentComponent
} from "../../../common/enrollment-request/individual-bed-enrollment/individual-bed-enrollment.component";
import { EnrollmentType } from "../../../domain/enums/enrollment-type.enum";
import {
  PropertyManagementEnrollmentComponent
} from "../../../common/enrollment-request/property-management-enrollment/property-management-enrollment.component";
import {
  IndividualOwnerEnrollmentComponent
} from "../../../common/enrollment-request/individual-owner-enrollment/individual-owner-enrollment.component";
import {TaskType} from "../../../domain/enums/task-type.enum";
import {UnderConstructionComponent} from "../../../common/under-construction/under-construction.component";
import {NewCustomerTaskComponent} from "./components/new-customer-task/new-customer-task.component";
import {InactivateTaskDetailComponent} from "./components/inactivate-task-detail/inactivate-task-detail.component";
import {NewPropertyTaskComponent} from "./components/new-property-task/new-property-task.component";

@Component({
  selector: 'app-task-detail',
  standalone: true,
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    FormsModule,
    RouterModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    ReactiveFormsModule,
    MatDividerModule,
    CommonModule,
    TaskDetailHeaderComponent,
    DefaultEnrollmentComponent,
    IndividualBedEnrollmentComponent,
    PropertyManagementEnrollmentComponent,
    IndividualOwnerEnrollmentComponent,
    InactivateTaskDetailComponent,
    UnderConstructionComponent,
    NewCustomerTaskComponent,
    NewPropertyTaskComponent,
  ],
  templateUrl: './task-detail.component.html',
  styleUrl: './task-detail.component.css'
})
export class TaskDetailComponent implements OnInit {
  @ViewChild(DefaultEnrollmentComponent) defaultEnrollmentComponent!: DefaultEnrollmentComponent;
  @ViewChild(IndividualBedEnrollmentComponent) individualBedEnrollmentComponent!: IndividualBedEnrollmentComponent;
  @ViewChild(IndividualOwnerEnrollmentComponent) individualOwnerEnrollmentComponent!: IndividualOwnerEnrollmentComponent;
  @ViewChild(PropertyManagementEnrollmentComponent) propertyManagementEnrollmentComponent!: PropertyManagementEnrollmentComponent;
  currentTask!: TaskModel;
  protected readonly EnrollmentType = EnrollmentType;
  disableSubmit = false;

  constructor(private readonly taskService: TaskService,
    private readonly route: ActivatedRoute,
    private readonly discovery: DiscoveryService,
    private readonly router: Router) {
  }

  /** Suspected Rental: acknowledge the task, then open the case the pipeline already created. */
  createCase(): void {
    const caseId = this.currentTask!.relatedEntityId;
    const open = () => this.router.navigate(['/app/discovery', caseId]);
    this.discovery.acknowledge(caseId).subscribe({ next: open, error: open });
  }

  ngOnInit(): void {
    const id: number = Number(this.route.snapshot.params['id']);
    if (id) {
      this.taskService.getById(id).subscribe(task => {
        this.currentTask = task;
        this.lock(task);
      });
    }
  }

  private lock(task: TaskModel) {
    /*this.taskService.lock(task).subscribe(() => {
      this.recentlyLocked = true;
    })*/
  }

  protected readonly TaskStatusEnum = TaskStatusEnum;
  protected readonly TaskType = TaskType;
}
